import { Component } from '@angular/core';

@Component({
  selector: 'app-lang-select',
  templateUrl: './lang-select.component.html',
  styleUrls: ['./lang-select.component.scss']
})
export class LangSelectComponent {
  selectedLang = localStorage.getItem('student_lang') || 'vi';

  change(lang: string): void {
    this.selectedLang = lang;
    console.log(lang, this.selectedLang)
    localStorage.setItem('student_lang', this.selectedLang);
    location.reload();
  }
}
